/* eslint-disable */
import { TextStyle } from './common.js';

export interface ParagraphData {
  /** Styling for the paragraph text. */
  textStyle?: TextStyle;
  /** Indentation level from 1-4. */
  indentation?: number;
  /** Paragraph level */
  level?: number;
}

const baseParagraphData: object = {};

export const ParagraphData = {
  fromJSON(object: any): ParagraphData {
    const message = { ...baseParagraphData } as ParagraphData;
    message.textStyle =
      object.textStyle !== undefined && object.textStyle !== null
        ? TextStyle.fromJSON(object.textStyle)
        : undefined;
    message.indentation =
      object.indentation !== undefined && object.indentation !== null
        ? Number(object.indentation)
        : undefined;
    message.level =
      object.level !== undefined && object.level !== null ? Number(object.level) : undefined;
    return message;
  },

  toJSON(message: ParagraphData): unknown {
    const obj: any = {};
    message.textStyle !== undefined &&
      (obj.textStyle = message.textStyle ? TextStyle.toJSON(message.textStyle) : undefined);
    message.indentation !== undefined && (obj.indentation = message.indentation);
    message.level !== undefined && (obj.level = message.level);
    return obj;
  },
};
